//  Badge tokens from _StateDuplicate (game: DnCashShopTask.cpp strStateName[]).
export enum CashShopBadge {
    Close = 'CLOSE',
    Hot = 'HOT',
    New = 'NEW',
    Event = 'EVENT',
    Discount = 'DISCOUNT',
    Limited = 'LIMITED',
    Sale = 'SALE',
    CountLimit = 'COUNTLIMIT',
}

//  _ItemSort (game: DnCashShopDefine.h eCashShopItemType).
export enum CashCommodityType {
    Costume = 0,
    Function = 1,
    Package = 2,
    Term = 3,
    DolisPackage = 4,
}

export interface ICashShopSubTab {
    stNum: number;
    nameId: number;
    name: string;
    visible: boolean;
}

export interface ICashShopTab {
    mtNum: number;
    nameId: number;
    name: string;
    visible: boolean;
    subTabs: ICashShopSubTab[];
}

export interface ICashShopEntryCurrencies {
    cash: boolean;   // _CashAble
    snda: boolean;   // _SNDACash (2nd currency)
    third: boolean;  // _3rdCash
    seed: boolean;   // _SeedAble
}

export default interface ICashShopEntry {
    sn: number;
    category: number;
    subCategory: number;
    nameId: number;
    name: string;
    descriptionId: number;
    description: string;
    //  Uistring params for descriptionId (only set via -1 inheritance from the
    //  granted item's _DescriptionIDParam; cashcommodity itself has no params).
    descriptionParams: string;
    itemIds: number[];   // non-zero _ItemID01..05; [0] is the primary item
    linkSns: number[];   // non-zero _LinkSN01..05 (period/color variants)
    count: number;
    price: number;
    priceFix: number;    // crossed-out original price when > 0
    paySale: number;     // VIP auto-pay discount percent
    vipPrice: number;
    periodText: string;
    badges: CashShopBadge[];
    type: CashCommodityType;
    //  Game rule: package-ness is determined by the existence of a
    //  cashpackagetable entry, NOT by _ItemSort (which is wrong on some rows).
    //  Set by the provider's enrichment pass.
    isPackage: boolean;
    onSale: boolean;
    onSaleReal: boolean;
    giftable: boolean;
    dnpAble: boolean;   // _ReserveAble — purchasable with DNP on duck
    limited: boolean;    // _Limit
    overlapBuy: number;
    buyLevel: number;
    priority: number;
    currencies: ICashShopEntryCurrencies;
}
